import { Box, Typography } from '@mui/material'

interface PopularSearchProps {
  items: Array<{ query_text: string }>
  translatedTitle: string
  onSelect: (text: string) => void
}

export const PopularSearch = ({ items, translatedTitle, onSelect }: PopularSearchProps) => {
  return (
    <Box sx={{display: { xs: 'none', sm: 'block' } }}>
      <Typography variant="body2" sx={{ fontWeight: 600, display: 'inline-block' }}>
        {translatedTitle}:
      </Typography>
      {items.slice(0, 5).map((item, index) => (
        <Typography
          onClick={() => onSelect(item?.query_text)}
          key={index}
          variant="body2"
          sx={{
            '&:hover': { color: 'primary.main' },
            fontWeight: 600,
            cursor: 'pointer',
            display: 'inline-block',
            marginLeft: '8px',
          }}
        >
          {item?.query_text}
        </Typography>
      ))}
    </Box>
  )
}